import React from "react";

const ProtectedRoute = ({ role, children }) => {
  const savedRole = localStorage.getItem("role");
  const uid = localStorage.getItem("uid");

  // 🛑 STOP THE REDIRECT: Show a message instead of Navigate
  if (!uid || savedRole !== role) {
    return (
      <div style={{
        background: 'darkred', 
        color: 'white', 
        padding: '40px', 
        height: '100vh', 
        textAlign: 'center',
        fontFamily: 'monospace'
      }}>
        <h1>🛑 GUARD BLOCKED ACCESS</h1>
        <hr />
        <div style={{textAlign: 'left', display: 'inline-block', marginTop: '20px'}}>
          <p><b>1. Required Role:</b> {role}</p>
          <p><b>2. Found Role:</b> {savedRole || "NULL (Empty)"}</p>
          <p><b>3. User ID:</b> {uid ? "✅ Exists" : "❌ NULL (Missing)"}</p>
        </div>
        <br /><br />
        <button onClick={() => window.location.href = "/"} style={{padding: '10px 20px', cursor: 'pointer'}}>
          Back to Login
        </button>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;